import React from 'react';
import PageEnvelope from '../elements/PageEnvelope';
import CommunityPanel from '../elements/CommunityPanel';
import { Server } from 'src/server/server';
import './SitePage.css'
import './JoinCommunityPage.css'

interface JoinCommunityPageState {
  loading: boolean;
  communities: any[]
  more: string | null;
  loadingMore: boolean;
}

class JoinCommunityPage extends React.Component<{}, JoinCommunityPageState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      loading: true,
      communities: [],
      more: null,
      loadingMore: false
    }
  }

  componentDidMount(): void {
    this.findCommunities();
  }

  async findCommunities() {
    let userCommunities = Server.user.getCommunities();
    let ids = userCommunities.map((community: any) => community.id);

    let response = await Server.public.findCommunities({communities: ids});

    this.setState({loading: false});

    if(response.success)
      this.setState({communities: response.communities, more: response.more})
  }

  async onLoadMore() {

    let userCommunities = Server.user.getCommunities();
    let ids = userCommunities.map((community: any) => community.id);

    this.setState({loadingMore: true});

    let response = await Server.public.findCommunities({communities: ids, more: this.state.more});

    this.setState({loadingMore: false});

    let communities = [...this.state.communities, ...response.communities];

    if(response.success)
      this.setState({communities, more: response.more})
  }

  onVisit(community:any) {
    let url = window.location.host;
    if(url.indexOf('www') == 0)
      url = url.replace('www', community.slug)
    else
      url = community.slug + '.' + url;

    url = window.location.protocol + '//' + url;

    window.open(url, '_blank');
  }

  renderCommunities() {
    return (
      <div className="site-page-column">
        {this.state.communities.length == 0 ? 'No communities available.' : 
          this.state.communities.map((community, i) => (
            <CommunityPanel 
              key={i} 
              community={community} 
              onVisit={this.onVisit.bind(this)} 
            />
          ))
        }
        {this.state.more &&
          <div style={{textAlign: 'right'}}>
            <button onClick={()=>this.onLoadMore()}>{this.state.loadingMore ? 'Loading...' : 'Load More'}</button>
          </div>
        }
        
      </div>
    )
  }

  render() {
    return (
      <div className="site-page">
        <PageEnvelope width="500px">
          <div style={{textAlign: 'center', margin: '0px 0px 20px 0px'}}>
            Select a community to join.
          </div>
          <div>
            {this.state.loading ? <div className="site-page-panel">Loading...</div> : this.renderCommunities()}
          </div>
        </PageEnvelope>
      </div>
    )
  }
}

export default JoinCommunityPage;